<template>
  <section>
    <NavBar />
    <b-row no-gutters id="admin-main" class="my-5 mx-auto">
      <b-col lg="3" cols="12">
        <ListClientsSection
          class="bg-white shadow-sm rounded-lg px-5 py-4 mb-4"
        />
      </b-col>

      <b-col lg="9" cols="12" class="pl-lg-4">
        <div class="bg-primary shadow-sm rounded-lg px-5 py-4 mb-4">
          <h3 class="m-0 my-1 text-white">{{ getHeaderText }}</h3>
        </div>
        <b-row no-gutters class="mb-4" align-h="between">
          <b-col lg="6" cols="12" class="pr-lg-2">
            <ListSoftwaresCriticalSection
              class="bg-white shadow-sm rounded-lg p-5 h-100"
            />
          </b-col>
          <b-col lg="6" cols="12" class="mt-4 mt-lg-0 pl-lg-2">
            <ListSoftwaresWarningSection
              class="bg-white shadow-sm rounded-lg p-5 h-100"
            />
          </b-col>
        </b-row>
        <ListServersSection class="bg-white shadow-sm rounded-lg p-5 my-4" />
        <ChartNotificationsByClient
          :clientId="-1"
          class="bg-white shadow-sm rounded-lg p-5 position-relative"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { NavBar, ChartNotificationsByClient } from "@/components";
import {
  ListSoftwaresCriticalSection,
  ListClientsSection,
  ListSoftwaresWarningSection,
  ListServersSection
} from "@/sections";
/**
 * @description Panneau administrateur Radar
 * @author Samuel Colassin
 * @vue-computed {String} getHeaderText - Détermine l'en-tête du pannau admin
 */
export default {
  name: "AdminDashboard",
  components: {
    ListSoftwaresCriticalSection,
    ListSoftwaresWarningSection,
    ListClientsSection,
    ChartNotificationsByClient,
    ListServersSection,
    NavBar
  },
  computed: {
    getHeaderText() {
      return this.$i18n.t("adminDashboard.defaultHeader");
    }
  }
};
</script>

<style scoped lang="scss">
@media screen and (min-width: 1366px) {
  #admin-main {
    width: 1366px;
  }
}

@media screen and (max-width: 1025px) {
  #admin-main {
    width: 95%;
  }
}

@media screen and (max-width: 414px) {
  #admin-main {
    width: 100%;
  }
}
</style>
